import React, { useState } from "react"
import { Formik } from "formik"
import { Form, message, Typography } from "antd"
import { RegisterStudentCourse } from "./types"
import { onSubmitHandler } from "./common"
import { RegisterFormWrapper } from "./RegisterFormWrapper"
import { RegistrationFormProps } from "./RegistrationFormProps"
import { registerCourseCouponValidator } from "./RegisterCourseCouponField"
import { OutputCourseRegistration } from "../../lib/supabase/insertCourseRegistration"
import { getInitialValues } from "./RegisterFormWithSteps/getInitialValues"
import { getRegisterFormValidationSchema } from "./RegisterFormWithSteps/getRegisterFormValidationSchema"
import { CourseType } from "../../lib/prismic/Course"
import { getUTMParamsFromStorage } from "../../lib/utmParams"
import { RegistrationFormWithStepsInnerForm } from "./RegistrationFormWithStepsInnerForm"

message.config({
  top: 100
})

export const RegistrationFormWithSteps = ({ course, lecturer, capacityStatus, courseTechnology }: RegistrationFormProps) => {
  const [formCompleteSend, setFormCompleteSend] = useState<OutputCourseRegistration | null>(null)
  const [form] = Form.useForm()

  const courseWithEquipment = (course.equipmentPrice && course.equipmentPrice > 0) || false
  const initialValues: RegisterStudentCourse = getInitialValues(courseWithEquipment, course.price)
  const registerFormValidationSchema = getRegisterFormValidationSchema(courseWithEquipment, course.price)

  return (
    <RegisterFormWrapper>
      <Typography.Title level={2}>Registrační formulář</Typography.Title>

      <Typography.Paragraph>
        {course.price > 0 ? "Po odeslání registrace vám e-mailem zašleme informace k platbě. " : "Registrace je zdarma a žádné platební údaje nejsou potřeba. "}
        Před začátkem kurzu vám také doručíme všechny potřebné podrobnosti.
        {course.type === CourseType.online ? " Kurzy probíhají online a jsou přizpůsobeny věku a úrovni dětí. " : ""} Můžete je také zakoupit jako dárkový
        voucher (PDF). Pokud máte jakékoliv dotazy, kontaktujte nás.
      </Typography.Paragraph>

      <Formik<RegisterStudentCourse>
        initialValues={initialValues}
        onSubmit={async (values, formikHelpers) =>
          await onSubmitHandler(initialValues, values, formikHelpers, course, setFormCompleteSend, form.resetFields, getUTMParamsFromStorage())
        }
        validationSchema={registerFormValidationSchema}
        validate={async (values) => {
          return await registerCourseCouponValidator(values)
        }}>
        {({ values, handleSubmit, handleChange, setFieldValue, handleBlur, touched, errors, isSubmitting, validateField }) => {
          return (
            <RegistrationFormWithStepsInnerForm
              form={form}
              course={course}
              lecturer={lecturer}
              values={values}
              handleSubmit={handleSubmit}
              handleBlur={handleBlur}
              handleChange={handleChange}
              touched={touched}
              errors={errors}
              isSubmitting={isSubmitting}
              setFieldValue={setFieldValue}
              validateField={validateField}
              courseWithEquipment={courseWithEquipment}
              formCompleteSend={formCompleteSend}
              capacityStatus={capacityStatus}
              courseTechnology={courseTechnology}
            />
          )
        }}
      </Formik>
    </RegisterFormWrapper>
  )
}
